import { deDE, enUS, GridLocaleText, nlNL } from '@mui/x-data-grid-premium'

type TFunction = (key: string, options?: Record<string, unknown>) => string

export const getLocale = (
  language: string
): Partial<GridLocaleText> | undefined => {
  switch (language) {
    case 'de':
      return deDE.components.MuiDataGrid.defaultProps.localeText
    case 'en':
      return enUS.components.MuiDataGrid.defaultProps.localeText
    case 'nl':
      return nlNL.components.MuiDataGrid.defaultProps.localeText
    default:
      return undefined
  }
}

let tt: TFunction
export const initializeTranslations = (t: TFunction): void => {
  tt = t
}
export const getT = (): TFunction => {
  if (!tt) {
    throw new Error(
      'Translations not initialized. Call initializeTranslations first.'
    )
  }

  return tt
}
